import React, { useState, useLayoutEffect, useRef, useEffect } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AddToBase from './AddToBase';
import Api from '../../modules/Api';
import ApiError from '../shared/apiError/ApiError';


const AddExcToPlan = ({
    onBack,
    setSuccess,
    excId,
    payload
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [filterValue, setFilterValue] = useState('');
    const [data, setData] = useState();
    const [apiError, setApiError] = useState();
    const [errTitle, setErrTitle] = useState('');
    const currentPage = useRef(0);
    const totalPages = useRef(0);

    useLayoutEffect(() => {
        fetchData();
    }, [filterValue]);

    useLayoutEffect(() => {
        if (data) {
            if (data.data) {
                if (currentPage.current === 0) {
                    setDataList(data.data);
                } else {
                    const update = [...dataList, ...data.data];
                    setDataList(update);
                }
            };
            if (data.pageInfo) {
                totalPages.current = data.pageInfo.totalPages;
            };
        };
    }, [data]);

    const fetchData = () => {
        const params = {
            direction: 'ASC',
            keyword: filterValue,
            page: currentPage.current,
            size: 10,
            sortBy: 'Name'
        }
        setIsLoading(true);
        Api.searchPlans(params)
            .then(res => {
                setData(res);
                setIsLoading(false);
            })
            .catch(err => {
                handleApiError(err);
                setIsLoading(false);
            });
    }

    const onItemClick = (item) => {
        const update = () => {
            const update = Object.assign([], dataList);
            update.find(d => d.id === item.id).selected = !item.selected;
            setDataList(update);
        };

        if (!item.selected) {
            setIsLoading(true);
            const payloadToSend = payload();
            Api.addUsersToPlanExclusion(item.id, payloadToSend)
                .then(res => {
                    update();
                    if (setSuccess)
                        setSuccess(`Success! Exclusion has been added to plan.`);
                    setIsLoading(false);
                })
                .catch(err => {
                    setIsLoading(false);
                    handleApiError(err);
                })
        }
    }

    const toCreate = (name) => {
        setIsLoading(true);
        Api.createPlan({ name })
            .then(res => {
                currentPage.current = 0;
                fetchData();
                if (setSuccess)
                    setSuccess(`Success! Your list has been updated.`);

                setIsLoading(false);
            })
            .catch(err => {
                handleApiError(err);
                setIsLoading(false);
            })
    };

    const onSearch = (filter) => {
        currentPage.current = 0;
        setFilterValue(filter);
    }

    const handleApiError = (err) => {
        setApiError(err);
        if (err && err.originalMessage) {
            setErrTitle(err.originalMessage);
        }
    };

    const CancelError = () => {
        setApiError(null);
        setErrTitle('');
    };

    const onLoadMore = () => {
        if (currentPage.current < totalPages.current - 1) {
            currentPage.current++;
            fetchData();
        }
    };

    return (
        <>
            <AddToBase
                loading={isLoading}
                onBack={onBack}
                data={dataList}
                onCreate={toCreate}
                onChange={onItemClick}
                onSearch={onSearch}
                onLoadMore={onLoadMore}
                hideBottom
                createLabel={'Create plan'}
                headerLabel={'Add to plans'}
                searchPlaceHolder={'Search plan...'}
                createPlaceHolder={'Enter plan name'}
                noDataMessage={'It doesn’t look like you have any plan, start by creating one'}
            />
            <ApiError
                show={apiError}
                errTitle={errTitle}
                error={apiError}
                cancelFunction={CancelError}
            />
        </>
    )
};

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddExcToPlan));
